"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuWrapper = exports.ToggleWrapper = exports.Wrapper = exports.Container = void 0;
var styled_components_1 = require("styled-components");
var Theme_1 = require("../../Theme");
var OpenProps = {
    background: "#FFFFFF",
    border: "1px solid #DCE5EB",
    borderRadius: "6px",
    boxShadow: Theme_1.BoxShadow.Box30,
};
var ClosedProps = {
    backgroundColor: Theme_1.Color.Grey.G10,
    border: "1px solid transparent",
    borderRadius: "4px",
};
var InErrorProps = {
    borderColor: Theme_1.Color.Red.R60,
};
exports.Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    min-height: 32px;\n"], ["\n    position: relative;\n    min-height: 32px;\n"])));
exports.Wrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    box-sizing: border-box;\n    width: ", ";\n"], ["\n    box-sizing: border-box;\n    width: ", ";\n"])), function (props) { return props.Open ? props.Width : "100%"; });
exports.ToggleWrapper = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n    ", "\n    width: 100%;\n    overflow: hidden;\n    opacity: ", "\n"], ["\n    ", ";\n    ", "\n    width: 100%;\n    overflow: hidden;\n    opacity: ", "\n"])), function (props) { return props.Open ? __assign({}, OpenProps) : __assign({}, ClosedProps); }, function (props) { return props.HasErrors && InErrorProps; }, function (props) { return props.IsDisabled ? Theme_1.DisabledOpacity : 1; });
exports.MenuWrapper = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", ";\n    width: ", ";\n    height: 342px;\n    z-index: 1;\n"], ["\n    ", ";\n    width: ", ";\n    height: 342px;\n    z-index: 1;\n"])), function (props) { return props.Open ? __assign({}, OpenProps) : __assign({}, ClosedProps); }, function (props) { return props.Width ? props.Width : "100%"; });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
